import { combineReducers } from 'redux';
import { allReporting } from './all-reporting/reporting.reducer';
import { reporting } from './reporting/reporting.reducer';
export const scope3 = combineReducers({ reporting, allReporting });
